


























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { headers } from '@/pantallas/SucursalVirtual/Cotizador/CotizadorHeaders';
import { CotizadorService } from '@/pantallas/SucursalVirtual/Cotizador/CotizadorService';
import Datatable from '@/pantallas/SucursalVirtual/Cotizador/datatable.vue';
import moment from 'moment/moment';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import CotizacionModal from '@/pantallas/SucursalVirtual/Cotizador/CotizacionModal.vue';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import SucursalVirtuallInstance from '../comunes/instances';
import { actionsEvent_2 } from '@/setup';
import { ICellRendererParams } from 'ag-grid-community';
import Analitica from '@/pantallas/SucursalVirtual/analitica_uso';
import { params } from '../VerFacturacion/fetchDte';

@Component({
  name: 'Cotizador',
  components: {
    Datatable,
    DatePicker,
    CotizacionModal,
  },
})
export default class Cotizador extends ComponenteBase {
  accionesTotales: PermisoAccion[];
  loadingService = new LoadingService();
  clientId: string;
  isLoading: boolean = false;
  cotizadorService = new CotizadorService();
  headers = headers;
  readonly funcionalidad: Funcionalidades = Funcionalidades.Cotizador;
  analytic = new Analitica(245, window.location.href);
  dataTable: any = [];
  texto_reporte: string = '';
  showReporteGenerado: boolean = false;
  search: string = '';
  detalleSeleccionado: any = null;
  showInfoDialog: boolean = false;
  infoItems: any[] = [];
  formFields: any = {
    ejecutivo: {
      label: 'Ejecutivo',
      id: '',
      value: '',
    },
    razon_social: {
      label: 'Razón Social',
      id: '',
      value: null,
    },
    estado: {
      label: 'Estado',
      id: '',
      value: '',
    },
    cotizacion: {
      label: 'Nº Cotización',
      id: '',
      value: '',
    },
    fechaInicio: {
      label: 'Fecha Desde',
      id: 'desde',
      value: moment().subtract(1, 'month'),
      maxDate: moment(this.fechaMaxima) as moment.Moment,
    },
    fechaFin: {
      label: 'Fecha Hasta',
      id: 'hasta',
      value: moment(),
      maxDate: moment(this.fechaMaxima) as moment.Moment,
    },
  };
  tipo_modal: string = '';

  ejecutivosList: any = [];
  razonSocialList: any = [];
  estadosList: any = [
    { estado: 'Enviada' },
    { estado: 'Pendiente' },
    { estado: 'Por Enviar' },
  ];
  cotizacionesList: any = [];
  idToEdit: string = '';

  dialog: boolean = false;
  id_cotizacion: string = '';
  userData: any = {};
  currentEjecutivo: any = {};

  async mounted() {
    let entrada = await this.analytic.entrada();
  }

  async destroyed() {
    let salida = await this.analytic.salida(this.analytic.id_analitica);
  }

  constructor() {
    super();
    this.getClientId();
    actionsEvent_2.onEditar(this.handleEdit);
    actionsEvent_2.onVerPdf(this.handlePdf);
    actionsEvent_2.onEnviar(this.handleReenviar);
  }

  handleEdit(params: ICellRendererParams) {
    this.handleModal('edit');
    this.idToEdit = params.data.id;
  }

  async validateIdData(): Promise<number> {
    let validations: string[] = ['ejeVal'];
    var hasErrors: number = 0;
    for (const val of validations) {
      let validation = await this.$validator.validate(val);
      if (!validation) {
        hasErrors += 1;
      }
    }
    return hasErrors;
  }

  PDFContacto(url: string) {
    window.open(url, '_blank');
  }

  async handlePdf(params: ICellRendererParams) {
    let self = this;
    this.id_cotizacion = params.data.id;
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await this.cotizadorService.getPDFContactos(self.id_cotizacion);
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.infoItems = msResponse.dataContacto;
      this.showInfoDialog = true;
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    this.loadingService.hideLoading();
  }

  created() {
    let self = this;
    this.userData = JSON.parse(localStorage.getItem('user'));
    this.getEjecutivos();
    this.loadClients();
    SucursalVirtuallInstance.$on(
      'loadCotizaciones',
      (dataCotizaciones: any) => {
        self.cotizacionesList = dataCotizaciones;
      }
    );
  }

  onBtnExport() {
    this.loadingService.showLoading();
    var body: any = {
      id_cliente: this.clientId,
      headers: this.headers,
      exportOption: true,
      extension: 'csv',
      search: this.search,
      application: '',
    };
    SucursalVirtuallInstance.$emit('ExportCotizaciones');
    /*this.cotizadorService
      .exportCuadratura(
        this.clientId,
        JSON.parse(localStorage.getItem('user')).id,
        body
      )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        this.$snotify.error('Ocurrió un error. Intente nuevamente.', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });*/
  }

  async handleReenviar(params: ICellRendererParams) {
    let self = this;
    this.id_cotizacion = params.data.id;
    self.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await self.cotizadorService.EnviarCotizador(
      self.id_cotizacion,
      'Reenviar',
      this.clientId,
      this.userData.id
    );
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      self.id_cotizacion = msResponse.id_cotizacion;
      self.$snotify.success(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
      SucursalVirtuallInstance.$emit('loadData');
    } else {
      self.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    console.log(msResponse.MENSAJE_RESPUESTA);
    self.loadingService.hideLoading();
  }

  async getEjecutivos() {
    let self = this;
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await this.cotizadorService.getEjecutivos(this.userData.id);
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.ejecutivosList = msResponse.ejecutivos;
      let currentUser = this.ejecutivosList.find((obj: any) => {
        return obj.id == self.userData.id;
      });
      if (currentUser) {
        this.formFields.ejecutivo.value = currentUser.id;
        this.currentEjecutivo = currentUser;
        await this.handleBuscarClick();
      }
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    this.loadingService.hideLoading();
  }

  async loadClients() {
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await this.cotizadorService.getClients();
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.razonSocialList = msResponse.clientList;
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    this.loadingService.hideLoading();
  }

  async handleBuscarClick() {
    let self = this;
    this.loadingService.showLoading();
    const inicio = this.formFields.fechaInicio.value;
    const fin = this.formFields.fechaFin.value;
    let errors = await this.validateIdData();
    if (errors > 0) {
      this.$snotify.error('Existen campos sin completar', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }

    if (inicio.isAfter(fin)) {
      return false;
    }
    if (fin.isBefore(inicio)) {
      return false;
    }
    if (this.currentEjecutivo.isleader == 'f') {
      this.formFields.ejecutivo.value = this.currentEjecutivo.id;
    }
    SucursalVirtuallInstance.$emit('filterData', this.formFields);
  }
  searchData() {
    if (this.search.length > 2 || this.search.length == 0) {
      SucursalVirtuallInstance.$emit('onFilterChanged', this.search);
    }
  }

  handleModal(tipo: string) {
    this.dialog = true;
    this.tipo_modal = tipo;
  }

  async handleCierreModalCrear() {
    this.dialog = false;
    this.idToEdit = '';
    SucursalVirtuallInstance.$emit('loadData');
  }

  async clearFilters() {
    for (let key in this.formFields) {
      if (this.formFields.hasOwnProperty(key)) {
        if (key == 'fechaInicio') {
          this.formFields[key].value = moment().subtract(1, 'month');
        } else if (key == 'fechaFin') {
          this.formFields[key].value = moment();
        } else if (key != 'ejecutivo') {
          this.formFields[key].value = '';
        }
      }
    }
    SucursalVirtuallInstance.$emit('filterData', this.formFields);
  }

  clearAutocomplete(input: string) {
    if (this.formFields[input].value == undefined)
      this.formFields[input].value = '';
  }

  getClientId() {
    this.clientId = localStorage.getItem('clienteDefecto');
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }
}
